<style scoped>
    .tournament-no {
        font-size: 1.6rem;
        line-height: 22px;
        float: left;
        color: #0f98d8;
        font-family: NotoSansCJKkr-Bold;
    }
</style>
<template>
    <div class="tournament-list-wrap">
        <FixtureDetailMatchContent v-for="(match, matchIndex) in matchList" :key="`match ${matchIndex}`" :match="match" :tournament="tournament"></FixtureDetailMatchContent>
    </div>
</template>
<script>
    import FixtureDetailMatchContent from './FixtureDetailMatchContent'
    import {mapState} from 'vuex'

    export default {
        components:{FixtureDetailMatchContent},
        computed: {
            ...mapState('tournaments', ['tournament', 'matches'])
        },
        data() {
            return {
                matchList: [],

            }
        },
        methods: {
        },
        created() {
            this.loadingCheck = true
            const participantIndexingList = []

            this.matches.participantList.forEach(participant => {
                participantIndexingList[participant.participantId] = participant


            })
            const matchIndexingList = []
            this.matches.participantList.forEach(participant => {

                participant.matchList.forEach(match => {
                    if (match) {
                        if (participantIndexingList.hasOwnProperty(match.firstParticipantId)) {
                            match.firstParticipantInfo = participantIndexingList[match.firstParticipantId]
                        }

                        if (participantIndexingList.hasOwnProperty(match.secondParticipantId)) {
                            match.secondParticipantInfo = participantIndexingList[match.secondParticipantId]
                        }

                        matchIndexingList[match.matchId] = match
                    }
                })
            })

            matchIndexingList.forEach(match => {
                this.matchList.push(match)
            })



            this.loadingCheck = false
        }
    }
</script>
